import React from "react";
import { FilterFn } from "@tanstack/react-table";

interface WithContentProp {
  content?: string;
}

const globalFilter: FilterFn<any> = (row, columnId, value) => {
  return row.getVisibleCells().some(cell => {
    const cellValue = cell.getValue();
    let cellStringValue = '';

    if (React.isValidElement(cellValue)) {
      const element = cellValue as React.ReactElement<WithContentProp>;
      if (typeof element.props === 'object' && element.props !== null && 'content' in element.props && typeof element.props.content === 'string') {
        cellStringValue = element.props.content;
      }
    } else if (typeof cellValue === 'object' && cellValue !== null && 'label' in cellValue) {
      cellStringValue = String((cellValue as { label: string }).label);
    } else {
      cellStringValue = String(cellValue);
    }

    return cellStringValue.toLowerCase().includes(String(value).toLowerCase());
  });
};

export default globalFilter;